//---------- IMPORTAÇÕES ----------//
import { LeadsContext } from "../../context/LeadsContext";
import { useContext } from "react";
import { loadLeadsService, updateLeadService } from "../../services";
import { X } from "lucide-react";



//---------- EXPORTAÇÃO DO MODAL EDIT LEAD ----------//
export default function ModalEditLead() {



  //---------- CRIAÇÃO DE HOOKS ----------//
  const { isOpenModalEditLead, setIsOpenModalEditLead } = useContext(LeadsContext);
  const { leadSelected, setLeadSelected } = useContext(LeadsContext); // Estado que armazena qual o Lead foi Selecionado
  const { leads, setLeads } = useContext(LeadsContext);
  const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
  const { currentPage, setCurrentPage } = useContext(LeadsContext);
  const { statusFilter } = useContext(LeadsContext);
  const { tagFilter } = useContext(LeadsContext);
  const { total, setTotal } = useContext(LeadsContext);
  const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



  //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
  // Responsável por atualizar as leads via API
  // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage", "filterStatus" e "filterTag"
  // Armazena as leads no Estado "leads"
  // Armazena o total no Estado "total"
  async function handleRefreshLeads() {
    const offset = (currentPage - 1) * itemsPerPage;
    const term = "";
    const response = await loadLeadsService(itemsPerPage, offset, term, statusFilter, tagFilter, integrationsFilter);
    if (response) {
      setLeads(response.data.clientes);
      setTotal(response.data.total_clientes);
    }
  };



  //---------- FUNÇÃO ASSÍNCRONA HANDLE UPDATE LEAD ----------//
  async function handleUpdateLead() {
    const response = await updateLeadService(leadSelected);
    if (response) {
      setIsOpenModalEditLead(false);
      setLeadSelected(null);
      handleRefreshLeads();
    }
  };


  //---------- RETORNO CONDICIONAL DO MODAL EDIT LEAD ----------//
  return (
    <>
      {!isOpenModalEditLead || !leadSelected
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Editar Lead</h2>
                <button onClick={() => setIsOpenModalEditLead(false)}><X className="text-white" /></button>
              </div>
              <div className="flex flex-col gap-3">
                <input
                  type="text"
                  placeholder="Nome"
                  value={leadSelected.nome}
                  onChange={(e) => setLeadSelected({ ...leadSelected, nome: e.target.value })}
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08]"
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={leadSelected.email}
                  onChange={(e) => setLeadSelected({ ...leadSelected, email: e.target.value })}
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08]"
                />
                <input
                  type="text"
                  placeholder="Telefone"
                  value={leadSelected.telefone}
                  onChange={(e) => setLeadSelected({ ...leadSelected, telefone: e.target.value })}
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08]"
                />
                <div className="flex justify-end gap-3">
                  <button onClick={() => setIsOpenModalEditLead(false)} className="px-4 py-2 bg-surface-3 rounded">Cancelar</button>
                  <button onClick={handleUpdateLead} className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded">Salvar</button>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}
